import React from 'react'
import { Sliders as DashboardIcon } from 'react-feather'
import { navItems as dashboardItems } from '../components/sidebar/dashboardItems'
import { DashboardBase } from './DashboardBase'
import useAuth from '../hooks/useAuth'
import { ScrollRestoration } from 'react-router'

const Dashboard = ({ children }: { children?: React.JSX.Element }) => {
    const { user } = useAuth()
    let sidebarItems = [...dashboardItems]

    if (user?.groups?.includes('superadmin')) {
        sidebarItems = [
            {
                titleI18n: 'site.nav.adminSection',
                pages: [
                    {
                        titleI18n: 'site.nav.adminSection',
                        href: '/admin/dashboard',
                        icon: DashboardIcon,
                    },
                ],
            },
            ...sidebarItems,
        ]
    } else {
        const excludePages: string[] = ['/notes']
        sidebarItems = sidebarItems.map((section) => ({
            ...section,
            pages: section.pages.filter((page) => !excludePages.includes(page.href)),
        }))
    }

    return (
        <DashboardBase dashboardItems={sidebarItems}>
            <ScrollRestoration />
            {children}
        </DashboardBase>
    )
}

export default Dashboard
